import { Box, Checkbox, Typography } from '@mui/material';
import React from 'react';

const ParticipantsList = ({ participants, participantStatuses = {} }) => {
    const isParticipantReady = (index) => {
        const status = participantStatuses[index];
        return status === 'completed' || status === 'saved';
    };

    const getParticipantLabel = (participant, index) => {
        const firstName = participant.user?.first_name || '';
        const lastName = participant.user?.last_name || '';
        const fullName = `${firstName} ${lastName}`.trim();
        
        if (fullName) {
            return fullName;
        }
        
        // Fallback labels for empty names
        return index === 0 ? 'Lead Booker' : `Guest ${index}`;
    };

    return (
        <Box 
            sx={{ 
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                flexWrap: { md: 'wrap' },
                gap: { xs: 0, md: 0.5 },
                alignItems: 'flex-start'
            }}
        >
            {participants.map((participant, index) => (
                <Box 
                    key={participant.id || index}
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 1,
                        minWidth: 'fit-content',
                        flexShrink: 0,
                        opacity: isParticipantReady(index) ? 1 : 0.5
                    }}
                >
                    <Checkbox 
                        checked={isParticipantReady(index)} 
                        disabled 
                        size="small"
                    />
                    <Typography 
                        variant="body1" 
                        sx={{ 
                            whiteSpace: 'nowrap',
                            fontSize: getParticipantLabel(participant, index).startsWith('Guest') ? '16px' : undefined
                        }}
                    >
                        {getParticipantLabel(participant, index)}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default ParticipantsList; 